import { Component, ViewChild } from '@angular/core';
import { MdVendorsListingComponent } from './md-vendors-listing/md-vendors-listing.component';

@Component({
  selector: 'app-md-vendors',
  templateUrl: './md-vendors.component.html',
  styleUrls: ['./md-vendors.component.scss']
})
export class MdVendorsComponent {

  @ViewChild('vendorsListing') vendorsListingComponent!: MdVendorsListingComponent;

  onVendorAdded(): void {
    console.log('Vendor added successfully');
    // Trigger refresh of the vendors listing
    if (this.vendorsListingComponent) {
      this.vendorsListingComponent.onVendorAdded();
    }
  }

  onVendorUpdated(): void {
    console.log('Vendor updated successfully');
    // Trigger refresh of the vendors listing
    if (this.vendorsListingComponent) {
      this.vendorsListingComponent.onVendorUpdated();
    }
  }
}
